const tradeType = {
  GIVE: "GIVE",
  LAUNCH: "LAUNCH"
};

export { tradeType };
